import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./service/registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import axios from "./config";
import VueAxios from "vue-axios";
import moment from "moment";
import lodash from "lodash";
import swal from "sweetalert";
import numeral from "numeral";

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

Vue.prototype.$moment = moment;
Vue.prototype.$swal = swal;
Vue.prototype.$_ = lodash;
Vue.prototype.$lodash = lodash;
Vue.prototype.$numeral = lodash;

Vue.filter("defaultPaymentFormat", function(value) {
  return numeral(value).format();
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(value, "DD/MM/YYYY, HH:mm:ss", true).format(
      "DD MMMM YYYY - hh:mm A"
    );
  }
});

Vue.filter("formatDateOnly", function(value) {
  if (value) {
    return moment(value, "DD/MM/YYYY, HH:mm:ss", true).format("DD MMMM YYYY");
  }
});

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(value, "DD-MM-YYYY HH:mm:ss", true).format(
      "DD MMM YYYY - hh:mm A"
    );
  }
});

Vue.filter("dateTracking", function(value) {
  if (value) {
    return moment(value, "DD-MM-YYYY HH:mm:ss", true).format(
      "DD-MM-YY hh:mm A"
    );
  }
});

window.OneSignal = window.OneSignal || [];
var initConfig = {
  appId: "2724e2a7-585b-4411-aa52-a723dbd96f76" //apyogyi
};
OneSignal.push(function () {
  OneSignal.SERVICE_WORKER_PARAM = { scope: '/js/' };
  OneSignal.SERVICE_WORKER_PATH = 'js/OneSignalSDKWorker.js'
  OneSignal.SERVICE_WORKER_UPDATER_PATH = 'js/OneSignalSDKUpdaterWorker.js'
  OneSignal.init(initConfig);
});